let loaded = false;
document.addEventListener("DOMContentLoaded", function () {
  if (!loaded) {
    const cartFooter = document.querySelector(".cart__checkout__header");
    addMutationObserver(cartFooter, triggerTermsTranslate);
    // loaded = true;
  }
  addCheckboxTermsListener("input[name=checkout]", "click", checkTermsCheckbox);
  addCheckboxTermsListener(
    '[data-role="cart-terms-checkbox"]',
    "click",
    logUserCheck
  );
});

isNotifyReady = false;

function addMutationObserver(targetNode, customCallback) {
  // console.log("Observer | addMutationObserver added 1");
  // console.log(targetNode);
  if (targetNode) {
    // console.log("Observer | target on node");
    let config = { attributes: true, childList: true, subtree: true };
    const callback = function (mutationsList, observer) {
      // console.log("Observer | callback called");
      // isNotifyReady = false;
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        // console.log(mutation);
        if (mutation.type === "childList" && !loaded) {
          if (isNotifyReady == false) {
            customCallback();
          }
        }
      }
    };

    let observer = null;
    observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}

// const isCheckApp = (nodes) => {
// 	const nodeChildren = Array.from(nodes).map((node) => {
// 		return Array.from(node.children).map((child) => {
// 			console.log(child);

// 		});
// 	});
// 	console.log(nodeChildren);
// 	return nodeChildren;
// };

function triggerTermsTranslate() {
  const check = document.querySelector(".cart__checkout__header > p > label");
  if (check) {
    check.innerHTML = `${cartTranslations.termsConditionsPrefix} <a class='underline' target="_blank" href='/pages/terms-conditions'>${cartTranslations.termsConditionsSuffix} </a>`;
    loaded = true;
  }
}

const addCheckboxTermsListener = (selector, event, handler) => {
  let rootElement = document.querySelector("#MainContent");
  rootElement.addEventListener(
    event,
    function (evt) {
      var targetElement = evt.target;
      while (targetElement != null) {
        if (targetElement.matches(selector)) {
          handler(evt);
          return;
        }
        targetElement = targetElement.parentElement;
      }
    },
    true
  );
};

const checkTermsCheckbox = (e) => {
  const checkoutForm = document.getElementById("cart");
  const termsInput = document.querySelector("#terms-check");
  if (!termsInput.checked) {
    alert(window.theme.strings.termsNotify);
    e.preventDefault();
    return;
  }
};

const logUserCheck = (e) => {
  const checkoutForm = document.getElementById("cart");
  const termsInput = document.querySelector("#terms-check");

  const termsRecordInput = document.querySelector(
    "#agreed-to-the-terms-and-conditions-on"
  );
  termsRecordInput.value = termsInput.checked ? new Date() : "";
};
